<template>
  <el-tooltip
    v-if="content"
    effect="dark"
    placement="top"
    :content="content"
  >
    <i class="el-icon-question tool-tips-icon" />
  </el-tooltip>
</template>

<script>
export default {
  name: 'ToolTips',
  props: {
    content: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="stylus" scoped>
.tool-tips-icon
  margin-left 6px
  color #909399
  font-size 14px
  cursor pointer
</style>
